import React from 'react';
import {
  EmptyIllustrationFrame,
  EmptyIllustrationGroundShadow,
  EmptyIllustrationMiniCard,
  EmptyIllustrationSvg,
} from './empty-illustration';

export const StorylinesEmptyIllustration: React.FC = () => {
  return (
    <EmptyIllustrationFrame>
      <EmptyIllustrationSvg>
        <EmptyIllustrationGroundShadow />
        <path
          d="M120 128 C 104 100, 72 90, 48 54"
          stroke="var(--scribane-green)"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M120 128 C 122 94, 122 58, 122 32"
          stroke="var(--muted-foreground)"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
          opacity="0.55"
        />
        <path
          d="M120 128 C 138 100, 166 92, 190 58"
          stroke="var(--border)"
          strokeWidth="2.5"
          strokeLinecap="round"
          fill="none"
        />
        <rect x="78" y="126" width="84" height="34" rx="6" fill="var(--card)" stroke="var(--border)" strokeWidth="2" />
        <line x1="120" y1="126" x2="120" y2="160" stroke="var(--border)" strokeWidth="1.5" />
        <line x1="90" y1="136" x2="110" y2="136" stroke="var(--border)" strokeWidth="1.5" opacity="0.6" />
        <line x1="90" y1="144" x2="106" y2="144" stroke="var(--border)" strokeWidth="1.5" opacity="0.6" />
        <line x1="130" y1="136" x2="150" y2="136" stroke="var(--border)" strokeWidth="1.5" opacity="0.6" />
        <line x1="130" y1="144" x2="146" y2="144" stroke="var(--border)" strokeWidth="1.5" opacity="0.6" />
        <EmptyIllustrationMiniCard x={32} y={38} variant="a" tone="filled" />
        <EmptyIllustrationMiniCard x={105} y={14} variant="b" tone="outline-green" width={34} />
        <EmptyIllustrationMiniCard x={174} y={42} variant="c" tone="muted" />
      </EmptyIllustrationSvg>
    </EmptyIllustrationFrame>
  );
};
